import React from 'react';
import { Box } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  Navigation,
  HeroSection,
  ScrollBar,
  GridText,
  FeaturesGrid,
  DashboardShowCase,
  CTASection,
  Footer
} from './components';
import TasksLandingPage from './components/pages/operations/TasksLandingPage';
import CompanyCalendarLandingPage from './components/pages/operations/CompanyCalendarLandingPage';
import ScheduleLandingPage from './components/pages/operations/ScheduleLandingPage';
import CRMLandingPage from './components/pages/sales/CRMLandingPage';
import PriceListPage from './components/pages/sales/PriceListPage';
import BrandsLandingPage from './components/pages/products/BrandsLandingPage';
import ProductsLandingPage from './components/pages/products/ProductsLandingPage';
import FormulationLandingPage from './components/pages/products/FormulationLandingPage';
import InventoryLandingPage from './components/pages/inventory/InventoryLandingPage';
import QualityControlLandingPage from './components/pages/inventory/QualityControlLandingPage';
import VendorsLandingPage from './components/pages/inventory/VendorsLandingPage';
import BatchProductionLandingPage from './components/pages/manufacturing/BatchProductionLandingPage';
import LineProductionLandingPage from './components/pages/manufacturing/LineProductionLandingPage';
import EmployeeLandingPage from './components/pages/administration/EmployeeLandingPage';
import UserManagementPage from './components/pages/administration/UserManagementPage';

const LandingPage = ({ onNavigateToAuth }) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/task-manager" 
          element={<TasksLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/company-calendar" 
          element={<CompanyCalendarLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/schedule-management" 
          element={<ScheduleLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/crm" 
          element={<CRMLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/price-lists" 
          element={<PriceListPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/brand-management" 
          element={<BrandsLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/product-catalog" 
          element={<ProductsLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route
          path="/formulations"
          element={<FormulationLandingPage onNavigateToAuth={onNavigateToAuth} />}
        />
        <Route
          path="/batch-production"
          element={<BatchProductionLandingPage onNavigateToAuth={onNavigateToAuth} />}
        />
        <Route
          path="/line-production"
          element={<LineProductionLandingPage onNavigateToAuth={onNavigateToAuth} />}
        />
        <Route
          path="/inventory"
          element={<InventoryLandingPage onNavigateToAuth={onNavigateToAuth} />}
        />
        <Route 
          path="/quality-control" 
          element={<QualityControlLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/vendor-management" 
          element={<VendorsLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/employees" 
          element={<EmployeeLandingPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/user-management" 
          element={<UserManagementPage onNavigateToAuth={onNavigateToAuth} />} 
        />
        <Route 
          path="/" 
          element={
            <Box sx={{ minHeight: '100vh' }}>
              <Navigation onNavigateToAuth={onNavigateToAuth} />
              <HeroSection onNavigateToAuth={onNavigateToAuth} />
              <ScrollBar />
              <FeaturesGrid />
              <DashboardShowCase />
              <GridText />
              <CTASection onNavigateToAuth={onNavigateToAuth} />
              <Footer />
            </Box>
          } 
        />
      </Routes>
    </BrowserRouter>
  );
};

export default LandingPage;